module.exports = __webpack_public_path__ + "static/media/ko.383a511b.jpg";